import Upload from 'adeliom-upload-js';

const settings = {
    maxFileSize: 2,
    maxTotalFilesSize: 10,
    maxNbFiles: 5,
    limitCharacters: 10,
    displayMaxFileSize: true,
    displayRestSize: true,
    displayRestFiles: true,
    displayFilenameError: true,
    multiple: true,
    fileExtensions: [".jpg", ".jpeg", ".pdf", ".docx", ".doc"],
    language: window.currentLanguage,
    languages: {
         es: {
            textBtnUpload: 'Agregar un archivo',
            textBeforeUpload: 'Ningún archivo seleccionado',
            textAfterUpload: 'Sus archivos',
            textSizeRest: '{{number}} restantes',
            textFileRest: '{{number}} archivos restantes',
            textMaxFileSize: '{{number}} archivos',
            textFileNotValid: "Su archivo no es válido",
            textMultipleFileNotValid: "Sus archivos no son válidos",
            textFileTooBig: "Su archivo es demasiado grande",
            textMultipleFileTooBig: "Sus archivos son demasiado grandes",
            textTotalFilesSize: "El tamaño total de sus archivos es demasiado pesado",
            textTooManyFiles: "Demasiados archivos cargados",
            textTotalFiles: "Ha alcanzado el número máximo de archivos",
            textErrorUpload: "Error, el archivo no puede ser cargado"
        }
    }
}

let inputs = document.querySelectorAll('input[type="file"]');

inputs.forEach(function(input){
    let options = {...settings};
    options.selector = '#' + input.id;

    if ($(input).parents('.w-input').find('.w-input__upload').length) {
        return;
    }

    const uploadField = new Upload(options);
    uploadField.init();
});
